import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { SettingsTab } from '../state/useSettingsTab'

type SettingsTabsDef = {
  key: SettingsTab
}

const TABS: SettingsTabsDef[] = [
  { key: 'general' },
  { key: 'queries' },
  { key: 'clients' },
  { key: 'datasources' },
  { key: 'notifications' },
]

type SettingsTabsProps = {
  activeTab: SettingsTab
  onTabChange: (tab: SettingsTab) => void
}

export function SettingsTabs({ activeTab, onTabChange }: SettingsTabsProps) {
  const { t } = useTranslation('settings')

  return (
    <div className="flex gap-1 border-b border-border">
      {TABS.map(({ key }) => (
        <button
          key={key}
          type="button"
          onClick={() => onTabChange(key)}
          className={cn(
            'relative px-4 py-2.5 text-sm font-medium transition-colors',
            'border-b-2 -mb-px',
            activeTab === key
              ? 'border-primary text-foreground'
              : 'border-transparent text-muted-foreground hover:text-foreground',
          )}
        >
          {t(`tab.${key}`)}
        </button>
      ))}
    </div>
  )
}
